<agpr-take-over-panel
    [id]="id"
    header="DataConnector.newConnectionDialogHeading"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="false"
    (visibleChange)="closeDialog($event)"
    [width]="50"
>
  <div class="agpr-newConnectionDialog">
    <span>{{ 'DataConnector.connectionsSubHeadingParagraph' | localize }}</span>
    <div class="agpr-newConnectionDialog-content">
      <!-- Radio buttons -->
      <div class="agpr-newConnectionDialog-types">
        <div
          *ngFor="let type of connectionTypes; index as i"
          class="agpr-newConnectionDialog-type"
          [ngClass]="{'agpr-newConnectionDialog-type-divider': type.value === dataConnectorTypes.EMAIL_ACCOUNT && i > 0}"
        >
          <agpr-radio
            [id]="id + '_connectionType_' + i"
            [hiddenLabel]="type.label"
            [(ngModel)]="selectedConnectionType"
            (ngModelChange)="validateFormData()"
            name="connectionType"
            [value]="type.value"
          ></agpr-radio>
          <label class="agpr-newConnectionDialog-type-label">
            @if (type.icon) {
              <span
                  role="img"
                  class="agpr-newConnectionDialog-type-label-icon"
                  [ngClass]="type.icon"
              ></span>
            }
            @else {
              <img class="agpr-newConnectionDialog-type-label-icon" [src]="appBaseHref + type.iconUrl" alt="" aria-hidden="true"/>
            }
            <span>{{ type.label | localize }}</span>
          </label>
        </div>
      </div>
      <!-- Connection details -->
      <div class="agpr-newConnectionDialog-details" [agprLoading]="connectorPermissionsLoading">
        <div class="agpr-newConnectionDialog-details-heading">
          @if (selectedConnectionType === dataConnectorTypes.EMAIL_ACCOUNT) {
            <span
                role="img"
                class="agpr-newConnectionDialog-details-icon fa-regular fa-duotone fa-envelope"
            ></span>
          }
          @else {
            <img [src]="appBaseHref + connectionTypeToIcon[selectedConnectionType]" alt="" aria-hidden="true"/>
          }

          {{ connectionTypeToLocalizationKey[selectedConnectionType] | localize }}
          {{ (selectedConnectionType === dataConnectorTypes.GOOGLE_ANALYTICS_4 ?
            'DataConnector.newConnectionDialog.setup' : 'DataConnector.newConnectionDialog.connection')  | localize }}
        </div>

        @if (selectedConnectionType === dataConnectorTypes.EMAIL_ACCOUNT) {
            <span class="agpr-newConnectionDialog-details-description">{{ 'DataConnector.emailAccount.newConnection.description' | localize }}</span>
            <div class="agpr-newConnectionDialog-details-privacyDropdown">
            <agpr-dropdown
                [id]="id + '_privacyDropdown'"
                label="DataConnector.emailAccount.newConnection.privacy"
                infoCircleTooltip="DataConnector.emailAccount.newConnection.privacy.tooltip"
                [options]="privacyDropdownItems"
                [(ngModel)]="selectedPrivacy"
                (ngModelChange)="calculateRemaining()"
            ></agpr-dropdown>
            </div>
            <agpr-text-input
                [id]="'dataConnector_connectionName'"
                class="agpr-newConnectionDialog-details-nameInput"
                label="DataConnector.emailAccount.newConnection.name"
                placeholder="DataConnector.enterDataProviderName"
                [required]="true"
                [maxLength]="64"
                [(ngModel)]="connectionName"
                (ngModelChange)="validateFormData($event)"
                [bottomMargin]="false"
            >
            </agpr-text-input>
            <div>
            <agpr-text-input
                [id]="'dataConnector_connectionEmail'"
                [maxLength]="128"
                [required]="true"
                label="DataConnector.emailAccount.newConnection.email"
                [(ngModel)]="email"
                (ngModelChange)="validateEmail()"
                placeholder="DataConnector.emailAccount.newConnection.email.placeholder"
                [bottomMargin]="false"
                [ariaInvalid]="errors.wrongEmailFormat || errors.hasNoContactEmail"
                ariaDescribedBy="email_errors"
            >
            </agpr-text-input>
            <ul id="email_errors">
                <li>
                    <agpr-form-message *ngIf="errors.wrongEmailFormat && !errors.hasNoEmail">
                        {{ 'invalidEmailFormat' | localize }}
                    </agpr-form-message>
                </li>
                <li>
                    @if(errors.hasNoEmail) {
                      <agpr-form-message>
                          {{ 'DataConnector.emailAccount.newConnection.email.error' | localize }}
                      </agpr-form-message>
                    }

                    @if(errors.duplicateEmail) {
                      <agpr-form-message>
                          {{ 'DataConnector.emailAccount.newConnection.duplicateEmail.error' | localize }}
                      </agpr-form-message>
                    }
                </li>
            </ul>
            </div>

            @if (numOfRemaining) {
                <agpr-message
                    [severity]="messageSeverityEnum.info"
                    [bottomMargin]="false"
                >
                    {{ 'DataConnector.emailAccount.newConnection.remainingInfo' | localize:{number: numOfRemaining} }}
                    <a class="agpr-newConnectionDialog-details-link" (click)="getMoreConnections()">{{ 'DataConnector.emailAccount.newConnection.linkToGetMore' | localize }}</a>
                </agpr-message>
            }
            @else {
                <agpr-message
                    [severity]="messageSeverityEnum.error"
                    [bottomMargin]="false"
                >
                    {{ ('DataConnector.emailAccount.newConnection.limitReach.' + selectedPrivacy.value ) | localize }}
                </agpr-message>
                <div class="agpr-newConnectionDialog-details-upsell">
                    <div class="agpr-newConnectionDialog-details-upsell-heading">
                    <span
                        class="agpr-newConnectionDialog-details-upsell-icon fa-kit fa-agpr-data-connection"
                        aria-hidden="true"
                    ></span>
                    <div>{{ 'DataConnector.emailAccount.newConnection.upSell.heading' | localize}}</div>
                    </div>
                    <div class="agpr-newConnectionDialog-details-upsell-content">
                    <div>{{ 'DataConnector.emailAccount.newConnection.upSell.text' | localize}}</div>
                    </div>
                    <agpr-button
                        id="dataConnector_getMoreConnections'"
                        label="DataConnector.emailAccount.newConnection.upSell.actionButton"
                        [style]="buttonTypes.primary"
                        (click)="getMoreConnections()"
                        ariaLabel="DataConnector.emailAccount.newConnection.upSell.actionButton"
                    ></agpr-button>
                </div>
            }

            <div class="agpr-newConnectionDialog-details-providers">
                <div class="agpr-newConnectionDialog-details-providers-container">
                    <div class="agpr-newConnectionDialog-details-providers-nylas">
                        <img
                            src="https://brand.nylas.com/assets/downloads/logo_horizontal_png/Nylas-logo-horizontal-blue_.png"
                            class="agpr-newConnectionDialog-details-providers-nylas-icon"
                            [alt]="'DataConnector.emailAccount.newConnection.providers.providedBy' | localize"
                            width="250"
                        />
                        <div class="agpr-newConnectionDialog-details-providers-nylas-text">
                            {{ 'DataConnector.emailAccount.newConnection.providers.providedBy' | localize}}
                        </div>
                    </div>

                    <div class="agpr-newConnectionDialog-details-providers-list">
                        <div id="dataConnector_nylasProviders">{{ 'DataConnector.emailAccount.newConnection.providers.listHeader'| localize}}</div>
                        <ul
                            aria-describedby="dataConnector_nylasProviders"
                        >
                            <li>{{ 'DataConnector.emailAccount.newConnection.providers.google' | localize}}</li>
                            <li>{{ 'DataConnector.emailAccount.newConnection.providers.microsoft' | localize}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        }
        @else {
          <agpr-text-input
            [id]="'dataConnector.connectionName'"
            class="agpr-newConnectionDialog-details-nameInput"
            label="DataConnector.dataProviderName"
            placeholder="DataConnector.enterDataProviderName"
            [required]="true"
            [maxLength]="64"
            [(ngModel)]="connectionName"
            (ngModelChange)="validateFormData($event)"
            [bottomMargin]="false"
          >
          </agpr-text-input>
          <ng-container
            *ngTemplateOutlet="selectedConnectionType === dataConnectorTypes.GOOGLE_ANALYTICS || selectedConnectionType === dataConnectorTypes.GOOGLE_ANALYTICS_4 ? google : other"
          ></ng-container>
          <agpr-message
            [severity]="messageSeverityEnum.info"
          >
            {{ 'DataConnector.ifYouAreHavingTrouble' | localize }}
            <a [href]="helpLink" target="_blank">{{ 'DataConnector.setupInstructions' | localize }}</a>
          </agpr-message>
        }

        @if (connectorPermissionsLoading) {
            <agpr-message
                [severity]="messageSeverityEnum.info"
            >
                {{ 'DataConnector.connecting' | localize }}
            </agpr-message>
        }
      </div>
    </div>

    <ng-template #google>
      <agpr-file-upload
        [id]="'dataConnector.fileUpload'"
        [maxFiles]="1"
        [allowMultiple]="false"
        [holdFileData]="true"
        header="DataConnector.fileUploadHeader"
        [uppercaseHeader]="false"
        [supportedFileTypes]="jsonMIMETypes"
        [supportedFileTypesRegex]="jsonMIMETypesRegex"
        uploadButtonLabel="DataConnector.fileUploadChooseFile"
        placeholder="DataConnector.fileUploadPlaceholder"
        [(ngModel)]="uploadedFiles"
        (ngModelChange)="validateFormData($event)"
      >
      </agpr-file-upload>
    </ng-template>

    <ng-template #other>
      <!-- TODO add template for social data connections once defined -->
    </ng-template>
    <ng-template #takeOverFooterLeft>
      <agpr-button
        [id]="id + '_cancel'"
        label="Core.button.cancel"
        (click)="cancel()"
      >
      </agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
      <agpr-button
        [id]="id + '_ok'"
        [style]="buttonTypes.primary"
        [disabled]="!isFormDataValid || connectorPermissionsLoading"
        label="DataConnector.connect"
        (click)="addDataConnection()"
      >
      </agpr-button>
    </ng-template>
  </div>
</agpr-take-over-panel>
